module.exports = __webpack_public_path__ + "img/raw.ffcc63a6.svg";